import _ from 'lodash'
import React from 'react'
import { EnrollmentState } from 'src/graphql.generated'

const ParticipantState = ({ state }: { state: EnrollmentState }) => <>{_.startCase(_.toLower(state))}</>

export default ParticipantState
